import {
  SubscriptionFlowDefinition,
  type FlowAnswers,
  type RecapPolicy,
} from './SubscriptionFlowDefinition'
import type { AvailableBundlesParams } from '@/services/subscription'

/**
 * Civil liability journey (`/responsabilite-civile`, subcategory AVE).
 *
 * The decision tree consults only internet protection (DecisionTree::Ave):
 * yes → Sécurité (digital risks included), no → Indispensable. Both basic
 * bundles come back from `available_bundles` with one flagged `recommended`, so
 * the results screen shows both offers and lets the user pick.
 *
 * Like the other duration-based covers, the period is the chosen start date over
 * `duration` months — fixed to 12 here (an annual cover, no duration selector) —
 * and the price is the standard annual_price, so neither `period()` nor
 * `displayPrice()` is overridden. The cover renews tacitly (default).
 */

/** Front `internetProtection` answer → backend `internet_protection` param. */
const INTERNET_PROTECTION_TO_API: Record<string, boolean> = {
  yes: true,
  no: false,
}

export class CivilLiabilityFlow extends SubscriptionFlowDefinition {
  readonly product = 'civil' as const
  readonly subcategory = 'AVE' as const

  /** Annual cover paid upfront (no monthly option), renewing tacitly. Shows the
   *  STUD'LIFE club reassurance block under the recap. */
  readonly recap: RecapPolicy = {
    showPaymentSelector: false,
    showClub: true,
    tacitRow: 'yes',
    priceMode: 'duration',
  }

  /** Source of truth: DecisionTree::Ave on the backend. */
  readonly planReference: Record<string, number> = {
    security: 7,
    indispensable: 6,
  }

  bundlesParams(a: FlowAnswers): AvailableBundlesParams | null {
    if (!a.internetProtection) return null
    const internetProtection = INTERNET_PROTECTION_TO_API[a.internetProtection]
    if (internetProtection === undefined) return null
    return { subcategory: 'AVE', internetProtection }
  }
}
